const state = () => ({
  likeCount: {
    '1': {}, // 店舗
    '2': {}, // 記事
    '3': {}, // 動画
    '4': {}, // キャンペーン
    '5': {}  // クーポン
  },
  liked: {
    '1': {}, // 店舗
    '2': {}, // 記事
    '3': {}, // 動画
    '4': {}, // キャンペーン
    '5': {}  // クーポン
  },
  signupAppeal: false
})

// getters
const getters = {
  getLikeCount: (state) => {
    return state.likeCount;
  },
  getLiked: (state) => {
    return state.liked;
  },
  getSignupAppeal: (state) => {
    return state.signupAppeal;
  },
}

// actions
const actions = {
  setLikeCount ({ state, commit }, data) {
    commit('setLikeCount', data);
  },
  setLiked ({ state, commit }, data) {
    commit('setLiked', data);
  },
  setSignupAppeal ({ state, commit }, data) {
    commit('setSignupAppeal', data);
  }
}

// mutations
const mutations = {
  setLikeCount (state, data) {
    state.likeCount = data;
  },
  setLiked (state, data) {
    state.liked = data;
  },
  setSignupAppeal (state, data) {
    state.signupAppeal = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
